module.exports = __webpack_public_path__ + "img/wangyi.a23a0482.png";